<template>
  <div class="w-100">
    <el-tabs type="border-card" v-model="activeTab">
      <el-tab-pane label="Add Single Member" name="add-member">
        <span slot="label"><i class="el-icon-plus"></i> Add Single Member</span>
        <el-form :model="addMemberForm" :rules="addMemberRules" ref="addMemberForm">
      <el-row :gutter="20">
        <el-col :span="24" :md="12">
          <el-input-title required>First Name</el-input-title>
          <el-form-item prop="firstName">
            <el-input class="mt-05" v-model="addMemberForm.firstName" placeholder="Type here..." />
          </el-form-item>
        </el-col>
        <el-col :span="24" :md="12">
          <el-input-title required>Last Name</el-input-title>
          <el-form-item prop="lastName">
            <el-input class="mt-05" v-model="addMemberForm.lastName" placeholder="Type here..." />
          </el-form-item>
        </el-col>
        <el-col :span="24" :md="12">
          <el-input-title required>Birthdate</el-input-title>
          <el-form-item prop="birthdate">
            <el-date-input class="mt-05" v-model="addMemberForm.birthdate" placeholder="DD/MM/YYYY"/>
          </el-form-item>
        </el-col>
        <el-col :span="24" :md="12">
          <el-input-title required>Gender</el-input-title>
          <el-form-item prop="gender">
            <el-select class="mt-05 w-100" v-model="addMemberForm.gender" filterable :filter-method="handleGenderFilter" autocomplete placeholder="Select">
              <el-option
                v-for="item in filterGender"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="errorMessage">
          <el-alert show-icon type="error" :closable="false">
            <template>
              <span class="mb-10 break-word">
                <b class="c-warning">Note:</b> {{ errorMessage }}
              </span>
            </template>
          </el-alert>
        </el-col>
      </el-row>
      <el-row class="mt-15">
        <el-col class="text-right">
          <el-button
            @click="cancel"
          >Cancel</el-button>
          <el-button
            class="btn-highlight"
            @click="addMember"
          >Add Member</el-button>
        </el-col>
      </el-row>
    </el-form>
      </el-tab-pane>
      <el-tab-pane label="Import Members" name="import-members">
        <span slot="label"><i class="el-icon-upload"></i> Import Members</span>
    <div class="d-flex flex-column align-items-center align-content-center w-100 ">
      <el-alert
        show-icon
        type="info"
        title="Download the template and upload it to import members."
        class="mb-10"
        :closable="false"
      >
        <template>
          <span class="mb-10 break-word">
            <b class="c-warning">Note:</b> Only .xlsx files are supported. Date field must be entered DD/MM/YYYY.
          </span>
          <el-link type="primary" :underline="false" :href="downloadLink" icon="el-icon-download" download>Download Template</el-link>
        </template>
      </el-alert>
      <div class="d-flex align-items-center justify-content-center w-100" v-if="showUpload">
  <el-upload
    ref="upload"
    drag
    action="#"
    :auto-upload="false"
    :file-list="fileList"
    :accept="accept"
    :limit="1"
    :on-exceed="onUploadFile"
    class="w-100 mt-4 upload-container"
  >
    <i class="el-icon-upload"></i>
    <div class="el-upload__text">
      Drop file here or <em>click to upload</em>
    </div>
  </el-upload>
</div>
      <div class="mt-10 w-100">
          <el-alert v-for="(error, i) in errors" :key="i"
            type="error"
            :description="error"
            :closable="false"
            show-icon>
          </el-alert>
      </div>
      <div v-if="importedMembers.length" class="w-100">
          <!-- Table for Existing Members -->
          <div v-if="existingMembers.length">
          <el-divider class="mb-20" content-position="left">Existing Members</el-divider>
          <!-- alert for existing members -->
          <el-alert class="mb-10" v-if="existingMembers.length" type="warning" title="These members will be added to the registration" :closable="false" />
          <el-table class="mb-20" :data="existingMembers" border style="width: 100%">
            <el-table-column prop="profile.firstName" label="First Name" width="auto"></el-table-column>
            <el-table-column prop="profile.lastName" label="Last Name" width="auto"></el-table-column>
            <el-table-column prop="profile.dob" label="Date of Birth" width="120">
                <template slot-scope="scope">
                  {{ scope.row.profile.dob | formatDate('DD/MM/YYYY') }}
                </template>
            </el-table-column>
            <el-table-column prop="profile.gender" label="Gender" width="100"></el-table-column>
            <el-table-column prop="eligible" label="Status" width="120">
                <template slot-scope="scope">
                    <el-tag type="success" v-if="scope.row.eligible">Eligible</el-tag>
                    <el-tag type="danger" v-else>Ineligible</el-tag>
                </template>
            </el-table-column>
          </el-table>
          </div>

          <!-- Table for Non-Existing Members -->
          <div v-if="nonExistingMembers.length">
          <el-divider v-if="nonExistingMembers.length && existingMembers.length" class="mb-20" content-position="left">New Members</el-divider>
          <el-alert class="mb-10" v-if="nonExistingMembers.length && hasIneligibleMembers" type="warning" :title="`${ineligibleMemberNumber} ${ineligibleMemberNumber > 1 ? 'ineligible members' : 'ineligible member'} will not be added.`" :closable="false" />
          <el-table class="mb-20" :data="nonExistingMembers" border style="width: 100%">
            <el-table-column prop="firstName" label="First Name" width="auto"></el-table-column>
            <el-table-column prop="lastName" label="Last Name" width="auto"></el-table-column>
            <el-table-column prop="birthdate" label="Date of Birth" width="120"></el-table-column>
            <el-table-column prop="gender" label="Gender" width="100"></el-table-column>
            <el-table-column prop="eligible" label="Status" width="120">
                <template slot-scope="scope">
                    <el-tag type="success" v-if="scope.row.eligible">Eligible</el-tag>
                    <el-tag type="danger" v-else>Ineligible</el-tag>
                </template>
            </el-table-column>
          </el-table>
          </div>
      </div>
      <div class="mt-15">
          <el-button
            v-if="!importedMembers.length"
            class="btn-highlight"
            @click="submit"
          >Submit</el-button>
          <el-button
            v-if="importedMembers.length"
            @click="uploadAgain"
          >Upload </el-button>
          <el-button
          v-if="importedMembers.length"
            :disabled="isDisabled"
            class="btn-highlight"
            @click="addMembers"
          >Add Members</el-button>
      </div>
    </div>
  </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import * as XLSX from 'xlsx';
import moment from 'moment';
import _ from 'lodash';
import { genders } from '@/utils/constants';
import { calculateMemberAge } from '@/utils/helpers';
import { checkBirthdate, parseBirthdate } from '@/utils/form-helpers';
import downloadLink from '@/assets/templates/Members-Import-Template.xlsx';

export default {
  name: 'NewMember',
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  components: {
  },
  data() {
    return {
      activeTab: 'add-member',
      showUpload: true,
      fileList: [],
      errors: [],
      importedMembers: [],
      existingMembers: [],
      nonExistingMembers: [],
      downloadLink,
      errorMessage: '',
      imgUrlObj: {},
      genders,
      nationalId: +process.env.VUE_APP_NATIONAL_ID,
      addMemberForm: {
        firstName: '',
        lastName: '',
        birthdate: '',
        gender: '',
        mainProfile: false
      },
      addMemberRules: {
        firstName: [
          { required: true, message: 'First Name is required', trigger: 'blur' }
        ],
        lastName: [
          { required: true, message: 'Last Name is required', trigger: 'blur' }
        ],
        birthdate: [
          { validator: checkBirthdate, trigger: 'blur' }
        ],
        gender: [
          { required: true, message: 'Gender is required', trigger: 'blur' }
        ]
      }
    };
  },
  computed: {
    accept() {
      return 'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    },
    filterGender() {
      if (this.nationalId === 10) {
        return [
          { value: 'Male', label: 'Male' },
          { value: 'Female', label: 'Female' },
          { value: 'Non-binary', label: 'Non-binary' }
        ];
      }
      return [
        { value: 'Male', label: 'Male' },
        { value: 'Female', label: 'Female' },
        { value: 'Other', label: 'Other' }
      ];
    },
    isDisabled() {
      const isEligible = this.importedMembers.every((member) => member.eligible);
      return !isEligible;
    },
    hasIneligibleMembers() {
      return this.nonExistingMembers.some((member) => !member.eligible);
    },
    ineligibleMemberNumber() {
      return this.nonExistingMembers.filter((member) => !member.eligible).length;
    }
  },
  methods: {
    onUploadFile(file) {
      this.errors = [];
      const f = file.item(0);
      this.fileList = [{ name: f.name, raw: f }];
    },
    async process(file) {
      this.errors = [];
      if (!file) return false;
      if (!['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'].includes(file.type)) {
        this.$message.error('Invalid file format. It should be .xls, .xlsx.');
        return false;
      }
      console.log(XLSX);
      return new Promise((res) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          let binary = '';
          const bytes = new Uint8Array(e.target.result);
          const length = bytes.byteLength;
          for (let i = 0; i < length; i++) binary += String.fromCharCode(bytes[i]);
          const wb = XLSX.read(binary, { type: 'binary' });
          const ws = wb.Sheets[wb.SheetNames[0]];
          const objects = XLSX.utils.sheet_to_json(ws, {
            raw: false,
            header: ['firstName', 'lastName', 'birthdate', 'gender'],
            cellDates: true, // Ensure dates are read correctly
            dateNF: 'DD/MM/YYYY' // Specify the date format
          });
          objects.shift();

          objects.forEach(this.validate);
          if (this.errors.length) return res(false);

          const members = objects.map((o) => this.memberConverter(o));
          return res(members);
        };
        reader.readAsArrayBuffer(file);
      });
    },
    validate(doc, i) {
      const cols = {
        firstName: 'A',
        lastName: 'B',
        birthdate: 'C',
        gender: 'D'
      };
      const index = i + 2;
      const errors = [];

      if (!doc.firstName) {
        errors.push(`Missing first name at cell ${cols.firstName}${index}, please check your spreadsheet`);
      }

      if (!doc.lastName) {
        errors.push(`Missing last name at cell ${cols.lastName}${index}, please check your spreadsheet`);
      }
      if (!doc.birthdate || !moment(doc.birthdate, 'DD/MM/YYYY', true).isValid()) {
        errors.push(`Invalid birthdate '${doc.birthdate}' at cell ${cols.birthdate}${index}, valid date format must be DD/MM/YYYY, e.g. 01/01/2021`);
      }

      if (!['Male', 'Female', 'Other'].includes(doc.gender)) {
        errors.push(`Invalid gender '${doc.gender}' at cell ${cols.gender}${index}, gender must be Male, Female, or Other`);
      }

      this.errors = this.errors.concat(errors);
    },
    memberConverter(doc) {
      console.log('doc', doc);
      // eslint-disable-next-line no-param-reassign
      const isEligible = this.isEligibleForBulkRego(doc);
      return {
        firstName: doc.firstName,
        lastName: doc.lastName,
        birthdate: parseBirthdate(doc.birthdate),
        gender: doc.gender,
        eligible: isEligible
      };
    },
    isEligibleForBulkRego(member) {
      console.log('product', this.product);
      const { gender: memberGender } = member;
      const birthdate = parseBirthdate(member.birthdate);

      const age = this.calculateAge(birthdate);
      const { ageFrom, ageTo, gender } = this.product;
      return ageFrom <= age && ageTo >= age && (memberGender === gender || gender === 'All' || !gender || (gender === 'Other' && (memberGender !== 'Male' && memberGender !== 'Female')));
    },
    async submit() {
      this.errors = [];
      this.importedMembers = [];
      const uploaded = _.first(this.$refs.upload.uploadFiles);
      if (!uploaded) {
        this.$message.error('Invalid uploaded file');
        return false;
      }
      console.log('uploaded', uploaded);
      const members = await this.process(uploaded.raw);
      if (!members) return false;

      if (!members.length) {
        this.$message.error('Invalid uploaded file');
        return false;
      }
      console.log('members', members);
      // add imported members to the importedMembers array
      // call endpoint to check if members are eligible
      const checkExistingMembersRes = await this.$http.post('/assemble/api/v1/account/portal/members/check-exsiting', {
        members,
      });
      console.log('eligibleMembersRes', checkExistingMembersRes.data.data);
      const checkMembers = checkExistingMembersRes.data.data;
      if (checkMembers.length) {
        this.importedMembers = this.importedMembers.concat(checkMembers);
        this.existingMembers = checkMembers.filter((member) => member.isExist);
        this.nonExistingMembers = checkMembers.filter((member) => !member.isExist);
        console.log('noExistingMembers', this.nonExistingMembers);
        console.log('existingMembers', this.existingMembers);
      }
      this.showUpload = false;

      // Handle the members data as needed
      // For example, you can send it to the server or update the state
      return true;
    },
    async addMembers() {
      // bulk adding members, call post endpoint
      const membersToAdd = this.importedMembers.filter((member) => !member.isExist && member.eligible);
      let addedMembers = [];
      if (membersToAdd.length) {
        this.$store.commit('loading', { loading: true, text: 'Loading...' });
        const res = await this.$http.post('/assemble/api/v1/account/portal/members/bulk-add', {
          members: membersToAdd
        });
        console.log('res', res);
        // emit members to parent
        addedMembers = res.data.data;
      }
      const eligible = this.existingMembers.filter((member) => member.eligible);
      const combinedMems = eligible.concat(addedMembers);
      this.$emit('importedMembers', combinedMems);
      this.$store.commit('loading', false);
    },
    uploadAgain() {
      this.fileList = [];
      this.errors = [];
      this.importedMembers = [];
      this.showUpload = true;
    },
    handleGenderFilter(val) {
      if (val) {
        this.filterGender = this.genders.filter((item) => item.value.charAt(0).toLowerCase() === val.charAt(0).toLowerCase());
      } else {
        this.filterGender = this.genders;
      }
    },
    cancel() {
      this.$emit('updateVisible', false);
    },
    calculateAge(dob) {
      const endOfYear = this.$store.getters['national/endOfYear'];
      const age = calculateMemberAge(dob, endOfYear);
      return age;
    },
    addMember() {
      this.errorMessage = '';
      this.$refs.addMemberForm.validate((valid) => {
        if (valid) {
          const isEligible = this.isEligibleForBulkRego({
            firstName: this.addMemberForm.firstName,
            lastName: this.addMemberForm.lastName,
            birthdate: this.addMemberForm.birthdate,
            gender: this.addMemberForm.gender
          });

          if (!isEligible) {
            this.errorMessage = 'This member is not eligible to join the event. Please try again.';
            return;
          }
          this.$store.commit('loading', { loading: true, text: 'Loading...' });
          this.$http.post('/assemble/api/v1/account/portal/members/search', {
            forBulkRego: true,
            firstName: this.addMemberForm.firstName,
            lastName: this.addMemberForm.lastName,
            dob: parseBirthdate(this.addMemberForm.birthdate),
            gender: this.addMemberForm.gender,
          }).then((res) => {
            const members = res.data.data;
            if (members && members.length > 0) {
              // Member match found -> link member
              this.$emit(
                'updatePage',
                { name: 'link-member', title: 'Previous Member Profiles' },
                { members, newMember: this.addMemberForm }
              );
              this.$store.commit('loading', false);
            } else {
              // Member match not found -> create new member
              this.$confirm("No previous profile found, you can click 'Cancel' to search again or click 'OK' to create as a new member.", 'New Member Confirm')
                .then(() => {
                  const profile = {
                    firstName: this.addMemberForm.firstName,
                    lastName: this.addMemberForm.lastName,
                    dob: parseBirthdate(this.addMemberForm.birthdate),
                    gender: this.addMemberForm.gender,
                  };
                  this.$http.post('/assemble/api/v1/account/portal/members-no-link', {
                    profile,
                  }).then((response) => {
                    // emit member to parent
                    const member = {
                      _id: response.data.data,
                      profile
                    };
                    this.$emit('selectMember', member);
                    this.$message({ message: 'Member added successfully', type: 'success' });
                    this.$store.commit('loading', false);
                  }).catch((e2) => {
                    this.errorMessage = e2.response.data.message;
                    this.$store.commit('loading', false);
                  });
                }).catch(() => {
                });
            }
            this.$store.commit('loading', false);
            this.$store.commit('loading', false);
          }).catch((e) => {
            this.errorMessage = e.response.data.message;
            this.$store.commit('loading', false);
          });
        }
      });
    }
  },
  filters: {
    formatDate(date, format) {
      return moment(date).format(format);
    }
  },
  watch: {
    // imgUrlObj(val) {
    //   this.imgUrlObj = val;
    // }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-upload-dragger {
  // width: 628px;
}
.upload-container {
  ::v-deep .el-upload {
    width: 100%;
  }

  ::v-deep .el-upload-dragger {
    width: 100%;
    // max-width: 628px;
  }
}
</style>
